import { Component, inject } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { CoreModalFooter, CoreModalWindow, MODAL_REF, ModalRef } from "@svs/angular";
import { SettingsStore, TextSize } from "../../@core/state/settings.store";
import {
  SettingsContrastModeToggleComponent,
} from "./settings-contrast-mode-toggle/settings-contrast-mode-toggle.component";
import {
  SettingsModalFontSizeSelectionComponent,
} from "./settings-modal-font-size-selection/settings-modal-font-size-selection.component";

@Component({
  selector: "app-settings-modal",
  imports: [
    CoreModalWindow,
    SettingsModalFontSizeSelectionComponent,
    CoreModalFooter,
    SettingsContrastModeToggleComponent,

  ],
  templateUrl: "./settings-modal.component.html",
  styleUrl: "./settings-modal.component.scss",
})
export class SettingsModalComponent {

  settingsStore = inject(SettingsStore);

  // @ts-ignore
  readonly modalRef: ModalRef = inject(MODAL_REF);

  settingsForm = new FormGroup({
    textSize: new FormControl<{ value: TextSize }>({ value: this.settingsStore.textSize() }),
    contrastMode: new FormControl(this.settingsStore.contrastMode()),
  });

  submit() {
    const settings = this.settingsForm.value;
    this.settingsStore.patch({
      contrastMode: settings.contrastMode,
      textSize: settings.textSize.value,
    });
    this.modalRef.close();
  }
}
